import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { parsePhoneNumberFromString } from 'libphonenumber-js';

import { PhoneInputForm } from './phone-input.models';

export function phoneNumberValidator(): ValidatorFn {
  return (control: AbstractControl<PhoneInputForm>): ValidationErrors | null => {
    const country = control.get('country')?.value;
    const nationalNumber = control.get('nationalNumber')?.value;

    if (!country || !nationalNumber) {
      return null;
    }

    const phoneNumber = parsePhoneNumberFromString(nationalNumber, country);

    if (!phoneNumber || !phoneNumber.isValid()) {
      return { phoneInvalid: 'validation.phone-number.invalid' };
    }

    return null;
  };
}
